module.exports = __webpack_public_path__ + "static/media/success.63460f03.svg";